/**
 * Historia przegladarki — WLASNY MODUL, celowo.
 *
 * DLACZEGO NIE W `src/index.tsx`
 * -----------------------------
 * Do wrzesnia 2026 `history` mieszkalo w punkcie wejscia aplikacji i 21
 * plikow importowalo je stamtad. Powstawal cykl:
 *
 *     index.tsx  ->  router.tsx  ->  ekrany  ->  index.tsx
 *
 * Webpack takie cykle toleruje, wiec aplikacja dzialala i nikt tego nie
 * widzial. Skutki byly jednak realne:
 *
 *   - zaimportowanie DOWOLNEGO z tych 21 plikow uruchamialo CALY rozruch
 *     aplikacji: tworzenie sklepu, start sag, rejestracje przechwytywaczy
 *     axiosa i `ReactDOM.render` do `#root`. Wyszlo to przy pisaniu testow
 *     (etap 0.2) — test jednego ekranu startowal cala aplikacje;
 *   - kolejnosc wykonania modulow w cyklu zalezy od narzedzia budujacego.
 *     Vite bywa mniej wyrozumialy niz webpack, a Vite to nastepny duzy
 *     etap planu aktualizacji.
 *
 * Ten modul nie importuje NICZEGO z aplikacji — tylko sama biblioteke.
 * Dzieki temu nie moze byc czescia zadnego cyklu.
 */
import { createBrowserHistory } from 'history';

export const history = createBrowserHistory();

export default history;
